import Copy from 'assets/img/icons/copy.svg';
import Button from 'components/_parts/atoms/button';
import CustomTable from 'components/_parts/atoms/table';
import ModalInquiry from 'components/_parts/molecules/modal/modalInquiry';
import { useCompetencyInquiryMutation } from 'components/company/hooks/useCompany';
import UseTabs from 'components/company/revamp/parts/setting/competencyLib/list/useTabs';
import LoadingCustom from 'components/layouts/loading/loading';
import dayjs from 'dayjs';
import { Hooks } from 'providers';
import { useOuterClick } from 'providers/OutsideClick';
import {
  useContext,
  useMemo,
  useState,
} from 'react';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import { useCompLibraryList } from 'components/company/api/useCompetencyAndSkillGroup';
import ModalActivityType from '../modal';
import ButtonCreate from './import';
import dataTab from './listTab';

interface PropsType {
  t: (e:string) => string
  tabComp : number
}

const ButtonMod = styled(Button)`
  width: 100%;
  width: 92px;
  height: 30px;
  float: right;
`;
const ButtonEdit = styled(Button)`
  width: 100%;
  max-width: 70px;
  height: 24px;
  float: right;
  margin-right: 7px;
`;
const ButtonCopyID = styled(Button)`
  width: 100%;
  width: 37px;
  height: 24px;
  float: right;
  background-color: #9aff5b;
`;
const CustomTableMod = styled.div`
  [data-column-id="1"] {
    min-width: 10%;
    tex-align: left;
  }
  .rdt_TableBody {
    height: 500px;
    overflow: auto;
  }
`;

const customStyles = {
  headCells: {
    style: {
      fontSize: '12px',
      fontWeight: 'bold',
      textAlign: 'center',
      fontFamily: 'Quicksand',
      padding: '0px',
      justifyContent: 'start',
    },
  },
  cells: {
    style: {
      padding: '0px',
      justifyContent: 'start',
    },
  },
  rows: {
    style: {
      fontFamily: 'Quicksand',
      minHeight: '35px', // override the row height
      borderRadius: 0,
      filter: 'none',
      borderBottom: 'unset !important',
    },
  },
};

function Index(props: PropsType) {
  const { t, tabComp } = props;
  const companyId = localStorage.getItem('company_id');
  const { listTab } = dataTab({ t });
  const { isActive, Render: renderTab } = UseTabs();
  const { setShowInquiryComp } = useContext(Hooks);
  const [showModal, setShowModal] = useState(false);
  const [competencyId, setCompetencyId] = useState('');
  const [typeForm, setTypeForm] = useState('');
  const [id, setId] = useState(null);
  const [dataEdit, setDataEdit] = useState(null);
  const competencyInquiryMutation = useCompetencyInquiryMutation();

  const typeCompetency = {
    0: 'core_competency',
    1: 'leadership_competency',
    2: 'technical_competency',
    3: 'functional_competency',
  };

  const dataPayload = {
    company_id: companyId,
    type: typeCompetency[isActive],
    status: 'active',
  };

  const { data: listCompLibrary, isFetching: loaderCompLibrary } = useCompLibraryList(companyId, typeCompetency[isActive], tabComp === 2);

  const innerRef = useOuterClick((e) => {
    const target = e?.target as HTMLElement;
    const className = target?.className;

    if (className && typeof className === 'string') {
      if (className === 'modal fade show' || className.includes('cs_modal-bg')) {
        setShowModal(false);
        setId(null);
      }
    }
  });

  // ACTION
  const actionId = (id: string) => (
    <ButtonCopyID
      func={() => {
        navigator.clipboard
          .writeText(id)
          .then(() => {
            toast.success('ID Copied!');
          })
          .catch(() => {
            toast.error('ID Not Copied!');
          });
      }}
    >
      <span>
        <img src={Copy} alt="copy_id" />
      </span>
    </ButtonCopyID>
  );

  const actionTable = ({ row, i }) => (
    <>
      <ButtonEdit
        icon="edit"
        func={() => {
          setShowModal(true);
          setTypeForm('edit');
          setId(i);
          setDataEdit(row);
        }}
      >
        <span className="tw-ml-[7px]">
          {t('org.structure_view.modal.edit')}
        </span>
      </ButtonEdit>
      <Button
        icon="delete"
        className="delCompLib"
        func={() => {
          competencyInquiryMutation.mutate({
            competency_id: row.competency_id,
            setShowInquiryComp,
          });
          setCompetencyId(row.competency_id);
          setCompetencyId(row.competency_id);
        }}
      />
    </>
  );

  const columns = useMemo(() => [
    {
      name: 'No',
      sortField: true,
      selector: (_, i) => i + 1,
      width: 'fit-content',
    },
    {
      name: 'ID',
      sortField: true,
      selector: (row) => actionId(row.competency_id),
    },
    {
      name: t('biz_process.tree.title'),
      sortField: true,
      selector: (row) => row.title,
    },
    {
      name: t('org.index_view.last_update'),
      sortField: true,
      selector: (row) => dayjs(row.updated_at).format('D MMM YYYY') ?? '-',
      center: true,
      width: '20%',
    },
    {
      name: t('wla.status.table.created_by'),
      sortField: true,
      selector: () => '-',
      center: true,
      width: '20%',
    },
    {
      name: t('org.employee.action'),
      sortField: true,
      style: {
        justifyContent: 'center',
      },
      center: true,
      width: '16%',
      cell: (row, i) => actionTable({ row, i }),
    },
  ], [t]);

  return (
    <>
      {showModal && (
      <ModalActivityType
        ref={innerRef}
        modal={showModal}
        funcModal={setShowModal}
        ids={id}
        data={dataEdit}
        funcId={() => setId}
        typeForm={typeForm}
        typeCompetency={typeCompetency[isActive]}
        t={t}
      />
      )}
      <ModalInquiry competencyId={competencyId} datas={dataPayload} />
      <div
        className="tab-pane active position-relative"
        id="activity_type_list"
        role="tabpanel"
        style={{
          minHeight: '700px',
        }}
      >
        <div className="row">
          <div className="col-12 mb-2">
            <h4 className="title">{t('company.competency_library')}</h4>
            {renderTab({ list: listTab })}
          </div>
          {(isActive !== 0 && isActive !== 1) && (
            <div className="col-12 d-flex justify-content-end align-items-center">
              <ButtonMod
                icon="create"
                func={() => {
                  setShowModal(true);
                  setTypeForm('create');
                  setDataEdit(null);
                }}
              >
              &nbsp;&nbsp;
                {t('board.add')}
              </ButtonMod>
              <ButtonCreate
                t={t}
              />
            </div>
          )}
        </div>

        <CustomTableMod>
          { loaderCompLibrary ? <LoadingCustom /> : (
            <CustomTable
              columns={columns}
              data={listCompLibrary}
              customStyles={customStyles}
            />
          )}

        </CustomTableMod>
      </div>
    </>
  );
}

export default Index;
